class NewsletterModal extends ModalElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
      return;
    }

    if (theme.config.isTouch) {
      new theme.initWhenVisible(this.init.bind(this));
    }
    else {
      this.init();
    }
  }

  get shouldLock() {
    return true;
  }

  get testMode() {
    return this.dataset.testMode === 'true';
  }

  get delay() {
    return parseInt(this.dataset.delay) || 5;
  }

  get expiry() {
    return parseInt(this.dataset.expiry) || 30;
  }

  get cookieName() {
    return 'concept:newsletter-popup';
  }

  get submited() {
    return this.querySelector('.alert') !== null;
  }

  init() {
    // Open modal if errors or success message exist
    if (this.submited) {
      this.load(1);
      return;
    }

    // Printtex : code de bienvenue déjà affiché à ce visiteur → la fenêtre ne se rouvre plus.
    let dejaInscrit = false;
    try { dejaInscrit = localStorage.getItem('ptx-bienvenue10') === '1'; } catch (e) {}
    if (dejaInscrit && !this.testMode) return;

    if (this.testMode || !this.getCookie(this.cookieName)) {
      this.load(this.delay);
    }
  }

  load(delay) {
    if (Shopify && Shopify.designMode) return;

    // Printtex (performance / SEO) : le délai démarre à la 1re action du visiteur (défilement, toucher, clic, touche).
    // Sans action (robots, tests Google), la fenêtre ne s'ouvre pas et ne compte pas comme « plus grand élément » (LCP).
    const evenements = ['scroll', 'pointerdown', 'touchstart', 'keydown'];
    const demarrer = () => {
      evenements.forEach((e) => window.removeEventListener(e, demarrer));
      setTimeout(() => this.show(), delay * 1000);
    };
    evenements.forEach((e) => window.addEventListener(e, demarrer, { passive: true, once: true }));
  }

  afterShow() {
    super.afterShow();
    this.classList.add('show-image');
  }

  afterHide() {
    super.afterHide();
    this.classList.remove('show-image');

    // Remove a cookie in case it was set in test mode
    if (this.testMode) {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('newsletter-modal', NewsletterModal);
